import { useEffect, useCallback } from "react";
import { useRecoilState } from "recoil";
import styled from "styled-components";

import { ClipFullModalState } from "../../../State/modals";
import { FloatingContainer, Modal } from "../../Wrappers";
import { EClipPageSource, ModalType } from "../../../@types";
import { CloseIcon } from "./styledComponents";
import Close from "../../../../assets/images/floatingannouncement/close.svg";
import ClipExperience from "MVVM/Views/ClipExperience";
import history from "../../../../history";

const ClipModal = () => {
  const [clipFullModalState, setClipFullModalState] =
    useRecoilState(ClipFullModalState);
  const { isOpen, shareId, orientation } = clipFullModalState;
  const closeModal = useCallback(() => {
    setClipFullModalState({
      ...clipFullModalState,
      isOpen: ModalType.None,
      contextOverride: null,
    });
  }, [clipFullModalState, setClipFullModalState]);

  useEffect(() => {
    if (isOpen !== ModalType.Clip) return;

    const unlisten = history.listen(() => {
      closeModal();
    });

    return () => {
      unlisten();
    };
  }, [isOpen, closeModal]);

  if (isOpen !== ModalType.Clip) return <></>;
  return (
    <Modal
      isModalOpen={isOpen === ModalType.Clip}
      setModalOpen={() => null}
      handleModalClose={closeModal}
      disableOutsideClose={undefined}
      style={{ overflow: "auto" }}
    >
      <StyledFloatingContainer>
        <CloseIcon
          size={40}
          src={Close}
          onClick={() => closeModal()}
          style={{ zIndex: 2 }}
        />
        {shareId && (
          <ClipExperience
            clipId={shareId}
            source={EClipPageSource.MODAL}
            orientation={orientation}
          />
        )}
      </StyledFloatingContainer>
    </Modal>
  );
};

const StyledFloatingContainer = styled(FloatingContainer)`
  align-items: stretch;
  background: ${({ theme }) => theme.colors.darkerNed};
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.ned};
  box-shadow: 0 0 0px #233438;
  flex-direction: column;
  height: 80%;
  justify-content: center;
  max-width: 1680px;
  padding: 8px;
  position: absolute;
  top: 20px;
  width: 80%;
  z-index: 101;

  @media (max-width: ${(props) => props.theme.breaks.standard}) {
    width: 90%;
  }
`;

export { ClipModal };
